import styled from 'styled-components';
import { media, colors } from '../settings';
import Text from '../components/Text';

export const ContentContainer = styled.div`
  margin: 60px 0;
`;

export const StyledUl = styled.ul`
  &.styled-ui{
    list-style: none;
    margin: 0;
  }
`;

export const MapLink = styled.a`
  text-decoration:underline;
  color: ${colors.black};
  display:inline-block;
`;

export const MapImg = styled.img`
  width:100%;
  display: inline-block;
  margin: 40px 0;

  ${media.greaterThan('md')`
    margin-top: 0;
  `}
`
export const StyledArrow = styled(Text.Body)`
  margin-left: 7px;
`

export const StyledTextBody = styled(Text.Body)`
  display: inline-block;
  width: 50%;

  ${media.greaterThan('lg')`
    width: 40%;
  `};

  ${media.greaterThan('lg')`
    width: 30%;
  `};
`;
